import axios from 'axios';

// Configuration de l'API
const API_BASE_URL = '/backend/api';
const DEBUG = true; // Mode debug activé

// Créer une instance axios avec la configuration de base
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Intercepteur pour les requêtes
api.interceptors.request.use(
  (config) => {
    
    // Ajouter le token d'authentification pour les requêtes admin
    const token = localStorage.getItem('admin_token');
    if (token && config.url?.includes('admin')) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Intercepteur pour les réponses
api.interceptors.response.use(
  (response) => {
    if (DEBUG) {
    }
    return response;
  },
  (error) => {
    if (DEBUG) {
    }
    return Promise.reject(error);
  }
);

// Fonction pour simuler une API en cas d'erreur
const mockApiResponse = (mockData: any) => {
  return Promise.resolve({ data: mockData });
};

// Services API
export const newsAPI = {
  getAll: async (params: { category?: string; featured?: boolean; limit?: number; page?: number; search?: string; lang?: string } = {}) => {
    try {
      const response = await api.get('/news.php', { params });
      return response.data;
    } catch (error) {
      // Données de secours en cas d'erreur avec plus d'articles pour tester les catégories
      return mockApiResponse({
        records: [
          {
            id: 1,
            title: 'Africa Surf Tour 2025 : Les Dates Révélées',
            content: 'Le calendrier officiel de l\'Africa Surf Tour 2025 vient d\'être dévoilé...',
            excerpt: 'Découvrez le calendrier complet de la saison 2025 avec 6 étapes inédites à travers le continent africain.',
            category: 'competitions',
            author: 'Équipe ASCsurf',
            image_url: 'https://images.pexels.com/photos/1430672/pexels-photo-1430672.jpeg?auto=compress&cs=tinysrgb&w=800',
            featured: true,
            tags: 'Africa Surf Tour,Compétitions,2025',
            read_time: 3,
            created_at: '2024-12-15T10:00:00Z'
          },
          {
            id: 2,
            title: 'Cherif Fall Qualifié pour les World Surf Games',
            content: 'Une nouvelle historique pour le surf africain...',
            excerpt: 'Le champion sénégalais décroche sa qualification pour représenter l\'Afrique aux World Surf Games 2025.',
            category: 'athletes',
            author: 'Mohamed Kone',
            image_url: 'https://images.pexels.com/photos/1308881/pexels-photo-1308881.jpeg?auto=compress&cs=tinysrgb&w=800',
            featured: false,
            tags: 'Cherif Fall,World Surf Games,Sénégal',
            read_time: 4,
            created_at: '2024-12-10T14:30:00Z'
          },
          {
            id: 3,
            title: 'Nouveau Centre de Formation à Taghazout',
            content: 'L\'ASCsurf inaugure son centre d\'excellence...',
            excerpt: 'L\'ASCsurf inaugure son centre d\'excellence pour former les futures stars du surf africain.',
            category: 'development',
            author: 'Sarah Benali',
            image_url: 'https://images.pexels.com/photos/1761279/pexels-photo-1761279.jpeg?auto=compress&cs=tinysrgb&w=800',
            featured: false,
            tags: 'Formation,Maroc,Jeunes',
            read_time: 5,
            created_at: '2024-12-05T09:00:00Z'
          },
          {
            id: 4,
            title: 'Partenariat avec Red Bull pour 2025',
            content: 'Un nouveau partenariat stratégique...',
            excerpt: 'Red Bull devient partenaire titre de l\'Africa Surf Tour pour développer le surf extrême.',
            category: 'partnerships',
            author: 'Équipe ASCsurf',
            image_url: 'https://images.pexels.com/photos/1650299/pexels-photo-1650299.jpeg?auto=compress&cs=tinysrgb&w=800',
            featured: true,
            tags: 'Red Bull,Partenariat,Sponsoring',
            read_time: 3,
            created_at: '2024-12-01T16:00:00Z'
          },
          {
            id: 5,
            title: 'Initiative Océan Propre au Sénégal',
            content: 'L\'ASCsurf lance une campagne environnementale...',
            excerpt: 'Une initiative pour protéger les océans et sensibiliser les communautés côtières.',
            category: 'environment',
            author: 'Aminata Diop',
            image_url: 'https://images.pexels.com/photos/1772123/pexels-photo-1772123.jpeg?auto=compress&cs=tinysrgb&w=800',
            featured: false,
            tags: 'Environnement,Océan,Sénégal',
            read_time: 6,
            created_at: '2024-11-28T11:00:00Z'
          }
        ].filter(article => {
          // Filtrer par catégorie si spécifiée
          if (params.category && params.category !== 'all') {
            return article.category === params.category;
          }
          return true;
        }),
        pagination: {
          current_page: 1,
          total_pages: 1,
          total_records: 5,
          limit: 10
        }
      }).then(res => res.data);
    }
  },
  
  getById: async (id: number, lang: string = 'fr') => {
    try {
      const response = await api.get(`/news.php?id=${id}&lang=${lang}`);
      return response.data;
    } catch (error) {
      // Donnée de secours en cas d'erreur
      return mockApiResponse({
        id: id,
        title: id === 1 ? 'Africa Surf Tour 2025 : Les Dates Révélées' : 'Cherif Fall Qualifié pour les World Surf Games',
        content: id === 1 
          ? 'Le calendrier officiel de l\'Africa Surf Tour 2025 vient d\'être dévoilé avec 6 étapes inédites à travers le continent africain. Cette nouvelle saison promet d\'être exceptionnelle avec des spots mythiques et des compétitions de haut niveau.'
          : 'Une nouvelle historique pour le surf africain avec la qualification de Cherif Fall pour les World Surf Games 2025. Le champion sénégalais représentera fièrement l\'Afrique sur la scène mondiale.',
        excerpt: id === 1 
          ? 'Découvrez le calendrier complet de la saison 2025 avec 6 étapes inédites à travers le continent africain.'
          : 'Le champion sénégalais décroche sa qualification pour représenter l\'Afrique aux World Surf Games 2025.',
        category: id === 1 ? 'competitions' : 'athletes',
        author: id === 1 ? 'Équipe ASCsurf' : 'Mohamed Kone',
        image_url: id === 1 
          ? 'https://images.pexels.com/photos/1430672/pexels-photo-1430672.jpeg?auto=compress&cs=tinysrgb&w=800'
          : 'https://images.pexels.com/photos/1308881/pexels-photo-1308881.jpeg?auto=compress&cs=tinysrgb&w=800',
        featured: id === 1,
        tags: id === 1 ? 'Africa Surf Tour,Compétitions,2025' : 'Cherif Fall,World Surf Games,Sénégal',
        read_time: id === 1 ? 3 : 4,
        created_at: id === 1 ? '2024-12-15T10:00:00Z' : '2024-12-10T14:30:00Z'
      }).then(res => res.data);
    }
  },
  
  getCategories: async () => {
    try {
      const response = await api.get('/news.php?categories=1');
      return response.data;
    } catch (error) {
      return mockApiResponse({
        records: [
          { category: 'competitions', count: 1 },
          { category: 'athletes', count: 1 },
          { category: 'development', count: 1 },
          { category: 'partnerships', count: 1 },
          { category: 'community', count: 0 },
          { category: 'environment', count: 1 }
        ]
      }).then(res => res.data);
    }
  },
  
  create: async (data: any) => {
    try {
      const response = await api.post('/news.php', data);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  
  update: async (data: any) => {
    try {
      const response = await api.put('/news.php', data);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  
  delete: async (id: number) => {
    try {
      const response = await api.delete('/news.php', { data: { id } });
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }
};

export const athletesAPI = {
  getAll: async (params: { category?: string; country?: string; limit?: number; page?: number; search?: string; lang?: string } = {}) => {
    try {
      const response = await api.get('/athletes.php', { params });
      return response.data;
    } catch (error) {
      return mockApiResponse({
        records: [
          {
            id: 1,
            name: 'Cherif Fall',
            country: 'Sénégal',
            category: 'professional',
            age: 24,
            specialty: 'Shortboard',
            ranking: 1,
            image_url: 'https://images.pexels.com/photos/1308881/pexels-photo-1308881.jpeg?auto=compress&cs=tinysrgb&w=600',
            bio: 'Prodige du surf sénégalais, Cherif Fall incarne la nouvelle génération de surfeurs africains.',
            achievements: 'Champion Africa Surf Tour 2024,Qualification WSL Challenger Series,3x Champion Sénégal',
            sponsors: 'Quiksilver,Red Bull,FCS',
            social_instagram: '@cheriffall_surf',
            social_youtube: 'Cherif Fall Surf',
            stats_competitions: 28,
            stats_wins: 12,
            stats_podiums: 20
          }
        ],
        pagination: {
          current_page: 1,
          total_pages: 1,
          total_records: 1,
          limit: 10
        }
      }).then(res => res.data);
    }
  },
  
  getById: async (id: number, lang: string = 'fr') => {
    try {
      const response = await api.get(`/athletes.php?id=${id}&lang=${lang}`);
      return response.data;
    } catch (error) {
      return mockApiResponse({
        id: 1,
        name: 'Cherif Fall',
        country: 'Sénégal',
        category: 'professional',
        age: 24,
        specialty: 'Shortboard',
        ranking: 1,
        image_url: 'https://images.pexels.com/photos/1308881/pexels-photo-1308881.jpeg?auto=compress&cs=tinysrgb&w=600',
        bio: 'Prodige du surf sénégalais, Cherif Fall incarne la nouvelle génération de surfeurs africains.',
        achievements: 'Champion Africa Surf Tour 2024,Qualification WSL Challenger Series,3x Champion Sénégal',
        sponsors: 'Quiksilver,Red Bull,FCS',
        social_instagram: '@cheriffall_surf',
        social_youtube: 'Cherif Fall Surf',
        stats_competitions: 28,
        stats_wins: 12,
        stats_podiums: 20
      }).then(res => res.data);
    }
  },
  
  getCountries: async () => {
    try {
      const response = await api.get('/athletes.php?countries=1');
      return response.data;
    } catch (error) {
      return mockApiResponse({
        records: [
          { country: 'Sénégal', count: 2 },
          { country: 'Maroc', count: 1 }
        ]
      }).then(res => res.data);
    }
  },
  
  create: async (data: any) => {
    try {
      const response = await api.post('/athletes.php', data);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  
  update: async (data: any) => {
    try {
      const response = await api.put('/athletes.php', data);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  
  delete: async (id: number) => {
    try {
      const response = await api.delete('/athletes.php', { data: { id } });
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }
};

export const federationsAPI = {
  getAll: async (params: { region?: string; limit?: number; page?: number; search?: string; lang?: string } = {}) => {
    try {
      const response = await api.get('/federations.php', { params });
      return response.data;
    } catch (error) {
      return mockApiResponse({
        records: [
          {
            id: 1,
            country: 'Sénégal',
            region: 'west',
            flag: '🇸🇳',
            president: 'Cherif Fall',
            founded: 2015,
            members: 120,
            logo_url: 'https://images.pexels.com/photos/1308881/pexels-photo-1308881.jpeg?auto=compress&cs=tinysrgb&w=200',
            spots: 'Yoff Beach,Ngor Right,Ouakam',
            achievements: 'Africa Surf Tour Winner 2024,3 Champions continentaux',
            contact_email: 'senegal@ascsurf.com',
            contact_phone: '+221 77 123 45 67',
            description: 'Pionnière du surf en Afrique de l\'Ouest, la fédération sénégalaise forme les futures stars.'
          }
        ],
        pagination: {
          current_page: 1,
          total_pages: 1,
          total_records: 1,
          limit: 10
        }
      }).then(res => res.data);
    }
  },
  
  getById: async (id: number, lang: string = 'fr') => {
    try {
      const response = await api.get(`/federations.php?id=${id}&lang=${lang}`);
      return response.data;
    } catch (error) {
      return mockApiResponse({
        id: 1,
        country: 'Sénégal',
        region: 'west',
        flag: '🇸🇳',
        president: 'Cherif Fall',
        founded: 2015,
        members: 120,
        logo_url: 'https://images.pexels.com/photos/1308881/pexels-photo-1308881.jpeg?auto=compress&cs=tinysrgb&w=200',
        spots: 'Yoff Beach,Ngor Right,Ouakam',
        achievements: 'Africa Surf Tour Winner 2024,3 Champions continentaux',
        contact_email: 'senegal@ascsurf.com',
        contact_phone: '+221 77 123 45 67',
        description: 'Pionnière du surf en Afrique de l\'Ouest, la fédération sénégalaise forme les futures stars.'
      }).then(res => res.data);
    }
  },
  
  getRegions: async () => {
    try {
      const response = await api.get('/federations.php?regions=1');
      return response.data;
    } catch (error) {
      return mockApiResponse({
        records: [
          { region: 'west', count: 2 },
          { region: 'north', count: 1 }
        ]
      }).then(res => res.data);
    }
  },
  
  create: async (data: any) => {
    try {
      const response = await api.post('/federations.php', data);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  
  update: async (data: any) => {
    try {
      const response = await api.put('/federations.php', data);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  
  delete: async (id: number) => {
    try {
      const response = await api.delete('/federations.php', { data: { id } });
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }
};

export const partnersAPI = {
  getAll: async (params: { category?: string; limit?: number; page?: number; search?: string } = {}) => {
    try {
      const response = await api.get('/partners.php', { params });
      return response.data;
    } catch (error) {
      return mockApiResponse({
        records: [
          {
            id: 1,
            name: 'Red Bull',
            category: 'title',
            logo_url: 'https://images.pexels.com/photos/1650299/pexels-photo-1650299.jpeg?auto=compress&cs=tinysrgb&w=200',
            website: 'redbull.com',
            description_fr: 'Partenaire principal pour le développement du surf extrême et des événements majeurs.',
            description_en: 'Main partner for extreme surfing development and major events.',
            partnership_since: 2023,
            testimonial_fr: 'L\'ASCsurf représente l\'avenir du surf mondial. Nous sommes fiers de soutenir cette vision.',
            testimonial_en: 'ASCsurf represents the future of world surfing. We are proud to support this vision.'
          },
          {
            id: 2,
            name: 'Quiksilver',
            category: 'equipment',
            logo_url: 'https://images.pexels.com/photos/1308881/pexels-photo-1308881.jpeg?auto=compress&cs=tinysrgb&w=200',
            website: 'quiksilver.com',
            description_fr: 'Fournisseur officiel d\'équipements et vêtements pour les athlètes ASCsurf.',
            description_en: 'Official supplier of equipment and clothing for ASCsurf athletes.',
            partnership_since: 2020,
            testimonial_fr: 'Le talent africain mérite le meilleur équipement. Nous sommes là pour les accompagner.',
            testimonial_en: 'African talent deserves the best equipment. We are here to support them.'
          }
        ],
        pagination: {
          current_page: 1,
          total_pages: 1,
          total_records: 2,
          limit: 10
        }
      }).then(res => res.data);
    }
  },
  
  getById: async (id: number) => {
    try {
      const response = await api.get(`/partners.php?id=${id}`);
      return response.data;
    } catch (error) {
      return mockApiResponse({
        id: 1,
        name: 'Red Bull',
        category: 'title',
        logo_url: 'https://images.pexels.com/photos/1650299/pexels-photo-1650299.jpeg?auto=compress&cs=tinysrgb&w=200',
        website: 'redbull.com',
        description_fr: 'Partenaire principal pour le développement du surf extrême et des événements majeurs.',
        description_en: 'Main partner for extreme surfing development and major events.',
        partnership_since: 2023,
        testimonial_fr: 'L\'ASCsurf représente l\'avenir du surf mondial. Nous sommes fiers de soutenir cette vision.',
        testimonial_en: 'ASCsurf represents the future of world surfing. We are proud to support this vision.'
      }).then(res => res.data);
    }
  },
  
  getCategories: async () => {
    try {
      const response = await api.get('/partners.php?categories=1');
      return response.data;
    } catch (error) {
      return mockApiResponse({
        records: [
          { category: 'title', count: 1 },
          { category: 'equipment', count: 1 }
        ]
      }).then(res => res.data);
    }
  },
  
  create: async (data: any) => {
    try {
      const response = await api.post('/partners.php', data);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  
  update: async (data: any) => {
    try {
      const response = await api.put('/partners.php', data);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  
  delete: async (id: number) => {
    try {
      const response = await api.delete('/partners.php', { data: { id } });
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }
};

export const galleryAPI = {
  getAll: async (params: { type?: string; collection?: string; active_only?: boolean; limit?: number; page?: number; search?: string } = {}) => {
    try {
      const response = await api.get('/gallery.php', { params });
      return response.data;
    } catch (error) {
      return mockApiResponse({
        records: [
          {
            id: 1,
            title_fr: 'Africa Surf Tour 2024 - Sénégal',
            title_en: 'Africa Surf Tour 2024 - Senegal',
            description_fr: 'Les meilleurs moments de l\'étape sénégalaise du tour',
            description_en: 'The best moments from the Senegalese stage of the tour',
            type: 'photos',
            collection: 'competitions',
            thumbnail_url: 'https://images.pexels.com/photos/1430672/pexels-photo-1430672.jpeg?auto=compress&cs=tinysrgb&w=600',
            media_count: 45,
            active: true,
            created_at: '2024-06-15T10:00:00Z'
          }
        ],
        pagination: {
          current_page: 1,
          total_pages: 1,
          total_records: 1,
          limit: 10
        }
      }).then(res => res.data);
    }
  },
  
  getById: async (id: number) => {
    try {
      const response = await api.get(`/gallery.php?id=${id}`);
      return response.data;
    } catch (error) {
      return mockApiResponse({
        id: 1,
        title_fr: 'Africa Surf Tour 2024 - Sénégal',
        title_en: 'Africa Surf Tour 2024 - Senegal',
        description_fr: 'Les meilleurs moments de l\'étape sénégalaise du tour',
        description_en: 'The best moments from the Senegalese stage of the tour',
        type: 'photos',
        collection: 'competitions',
        thumbnail_url: 'https://images.pexels.com/photos/1430672/pexels-photo-1430672.jpeg?auto=compress&cs=tinysrgb&w=600',
        media_count: 45,
        active: true,
        created_at: '2024-06-15T10:00:00Z',
        media: [
          {
            id: 1,
            gallery_id: 1,
            title_fr: 'Photo 1',
            title_en: 'Photo 1',
            media_url: 'https://images.pexels.com/photos/1430672/pexels-photo-1430672.jpeg?auto=compress&cs=tinysrgb&w=1200',
            media_type: 'image',
            order_position: 1
          },
          {
            id: 2,
            gallery_id: 1,
            title_fr: 'Photo 2',
            title_en: 'Photo 2',
            media_url: 'https://images.pexels.com/photos/1308881/pexels-photo-1308881.jpeg?auto=compress&cs=tinysrgb&w=1200',
            media_type: 'image',
            order_position: 2
          }
        ]
      }).then(res => res.data);
    }
  },
  
  getGalleryMedia: async (galleryId: number) => {
    try {
      const response = await api.get(`/gallery_media.php?gallery_id=${galleryId}`);
      return response.data;
    } catch (error) {
      return mockApiResponse({
        records: [
          {
            id: 1,
            gallery_id: galleryId,
            title_fr: 'Photo 1',
            title_en: 'Photo 1',
            media_url: 'https://images.pexels.com/photos/1430672/pexels-photo-1430672.jpeg?auto=compress&cs=tinysrgb&w=1200',
            media_type: 'image',
            order_position: 1
          },
          {
            id: 2,
            gallery_id: galleryId,
            title_fr: 'Photo 2',
            title_en: 'Photo 2',
            media_url: 'https://images.pexels.com/photos/1308881/pexels-photo-1308881.jpeg?auto=compress&cs=tinysrgb&w=1200',
            media_type: 'image',
            order_position: 2
          }
        ]
      }).then(res => res.data);
    }
  },
  
  getLatestMedia: async (limit: number = 12) => {
    try {
      const response = await api.get(`/gallery_media.php?latest=true&limit=${limit}`);
      return response.data;
    } catch (error) {
      return mockApiResponse({
        records: Array.from({ length: limit }, (_, i) => ({
          id: 1000 + i,
          gallery_id: i % 2 === 0 ? 1 : 2,
          title_fr: `Média récent ${i + 1}`,
          title_en: `Recent media ${i + 1}`,
          media_url: i % 3 === 0 
            ? `/videos/surf_video_${(i % 3) + 1}.mp4` 
            : `https://images.pexels.com/photos/${1400000 + i * 10000}/pexels-photo-${1400000 + i * 10000}.jpeg?auto=compress&cs=tinysrgb&w=300`,
          media_type: i % 3 === 0 ? 'video' : 'image',
          order_position: i + 1,
          created_at: new Date(Date.now() - i * 86400000).toISOString() // Dates décroissantes
        }))
      }).then(res => res.data);
    }
  },
  
  getCollections: async () => {
    try {
      const response = await api.get('/gallery.php?collections=1');
      return response.data;
    } catch (error) {
      return mockApiResponse({
        records: [
          { collection: 'competitions', count: 1 },
          { collection: 'spots', count: 1 }
        ]
      }).then(res => res.data);
    }
  },
  
  create: async (data: any) => {
    try {
      const response = await api.post('/gallery.php', data);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  
  update: async (data: any) => {
    try {
      const response = await api.put('/gallery.php', data);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  
  delete: async (id: number) => {
    try {
      const response = await api.delete('/gallery.php', { data: { id } });
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  
  addMedia: async (galleryId: number, mediaData: any) => {
    try {
      const response = await api.post('/gallery_media.php', { gallery_id: galleryId, ...mediaData });
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  
  deleteMedia: async (mediaId: number, galleryId: number) => {
    try {
      const response = await api.delete('/gallery_media.php', { data: { id: mediaId, gallery_id: galleryId } });
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }
};

export const tourStopsAPI = {
  getAll: async (params = {}) => {
    try {
      const response = await api.get('/tour_stops.php', { params });
      return response.data;
    } catch (error) {
      return mockApiResponse({
        records: [
          {
            id: 1,
            country: 'Sénégal',
            location: 'Dakar',
            dates: '15-20 Mars 2024',
            month: 'Mars',
            year: 2024,
            image_url: 'https://images.pexels.com/photos/17155141/pexels-photo-17155141.jpeg',
            description_fr: 'Première étape du tour dans les vagues puissantes de Yoff, berceau du surf sénégalais.',
            description_en: 'First stop of the tour in the powerful waves of Yoff, birthplace of Senegalese surfing.',
            highlights_fr: '48 surfeurs de 8 pays africains,Conditions parfaites avec 4-6 pieds,Performance exceptionnelle de Cherif Fall,Festival culturel wolof en parallèle',
            highlights_en: '48 surfers from 8 African countries,Perfect conditions with 4-6 feet waves,Exceptional performance by Cherif Fall,Parallel Wolof cultural festival',
            participants: 48,
            prize_pool: '25,000€',
            winner_men: 'Cherif Fall',
            winner_women: 'Amina Diop',
            created_at: '2024-01-15T10:00:00Z',
            updated_at: '2024-03-20T18:30:00Z',
            status: 'completed',
            spot: 'Yoff Beach'
          },
          {
            id: 2,
            country: 'Maroc',
            location: 'Taghazout',
            dates: '10-15 Avril 2024',
            month: 'Avril',
            year: 2024,
            image_url: 'https://images.pexels.com/photos/17105549/pexels-photo-17105549.jpeg',
            description_fr: 'Conditions exceptionnelles sur le reef break légendaire d\'Anchor Point.',
            description_en: 'Exceptional conditions on the legendary Anchor Point reef break.',
            highlights_fr: '52 surfeurs qualifiés,Vagues de 6-8 pieds parfaitement formées,Victoire historique de Youssef Benali,Retransmission live internationale',
            highlights_en: '52 qualified surfers,Perfectly formed 6-8 feet waves,Historic victory by Youssef Benali,International live broadcast',
            participants: 52,
            prize_pool: '30,000€',
            winner_men: 'Youssef Benali',
            winner_women: 'Fatima El Mansouri',
            created_at: '2024-02-01T09:00:00Z',
            updated_at: '2024-04-15T20:15:00Z',
            status: 'completed',
            spot: 'Anchor Point'
          },
          {
            id: 3,
            country: 'Ghana',
            location: 'Busua',
            dates: '15-20 Mai 2024',
            month: 'Mai',
            year: 2024,
            image_url: 'https://images.pexels.com/photos/1032650/pexels-photo-1032650.jpg',
            description_fr: 'Finale épique du championnat ASC 2024. Les 32 meilleurs surfeurs du continent s\'affrontent pour le titre.',
            description_en: 'Epic finale of the ASC 2024 championship. The 32 best surfers on the continent compete for the title.',
            highlights_fr: '32 surfeurs qualifiés de 15 pays,Prize money de 50,000€,Retransmission live internationale,Festival culturel et concerts,Cérémonie de clôture spectaculaire',
            highlights_en: '32 qualified surfers from 15 countries,50,000€ prize money,International live broadcast,Cultural festival and concerts,Spectacular closing ceremony',
            participants: 32,
            prize_pool: '50,000€',
            winner_men: null,
            winner_women: null,
            created_at: '2024-03-01T08:00:00Z',
            updated_at: '2024-04-20T14:30:00Z',
            status: 'featured',
            spot: 'Busua Beach'
          }
        ],
        pagination: {
          current_page: 1,
          total_pages: 1,
          total_records: 3,
          limit: 10
        }
      }).then(res => res.data);
    }
  },
  
  getById: async (id: number) => {
    try {
      const response = await api.get(`/tour_stops.php?id=${id}`);
      return response.data;
    } catch (error) {
      return mockApiResponse({
        id: 1,
        country: 'Sénégal',
        location: 'Dakar',
        dates: '15-20 Mars 2024',
        month: 'Mars',
        year: 2024,
        image_url: 'https://images.pexels.com/photos/17155141/pexels-photo-17155141.jpeg',
        description_fr: 'Première étape du tour dans les vagues puissantes de Yoff.',
        description_en: 'First stop of the tour in the powerful waves of Yoff.',
        highlights_fr: '48 surfeurs de 8 pays africains,Conditions parfaites avec 4-6 pieds',
        highlights_en: '48 surfers from 8 African countries,Perfect conditions with 4-6 feet waves',
        participants: 48,
        prize_pool: '25,000€',
        winner_men: 'Cherif Fall',
        winner_women: 'Amina Diop',
        status: 'completed',
        spot: 'Yoff Beach'
      }).then(res => res.data);
    }
  },

  getFeatured: async () => {
    try {
      const response = await api.get('/tour_stops.php?featured=1');
      return response.data;
    } catch (error) {
      return mockApiResponse({
        id: 3,
        country: 'Ghana',
        location: 'Busua',
        dates: '15-20 Mai 2024',
        month: 'Mai',
        year: 2024,
        image_url: 'https://images.pexels.com/photos/1032650/pexels-photo-1032650.jpg',
        description_fr: 'Finale épique du championnat ASC 2024.',
        description_en: 'Epic finale of the ASC 2024 championship.',
        highlights_fr: '32 surfeurs qualifiés de 15 pays,Prize money de 50,000€',
        highlights_en: '32 qualified surfers from 15 countries,50,000€ prize money',
        participants: 32,
        prize_pool: '50,000€',
        status: 'featured',
        spot: 'Busua Beach'
      }).then(res => res.data);
    }
  },

  setFeatured: async (id: number) => {
    try {
      const response = await api.put('/tour_stops.php', { id, status: 'featured' });
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  removeFeatured: async (id: number) => {
    try {
      const response = await api.put('/tour_stops.php', { id, status: 'upcoming' });
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  
  getByYear: async (year: number) => {
    try {
      const response = await api.get(`/tour_stops.php?year=${year}`);
      return response.data;
    } catch (error) {
      return mockApiResponse({
        records: [
          {
            id: 1,
            country: 'Sénégal',
            location: 'Yoff Beach, Dakar',
            dates: '15-18 Mars',
            month: 'Mars',
            year: 2024,
            image_url: 'https://images.pexels.com/photos/1430672/pexels-photo-1430672.jpeg?auto=compress&cs=tinysrgb&w=1200'
          },
          {
            id: 2,
            country: 'Côte d\'Ivoire',
            location: 'Assinie',
            dates: '12-15 Avril',
            month: 'Avril',
            year: 2024,
            image_url: 'https://images.pexels.com/photos/1619317/pexels-photo-1619317.jpeg?auto=compress&cs=tinysrgb&w=1200'
          }
        ]
      }).then(res => res.data);
    }
  },
  
  getYears: async () => {
    try {
      const response = await api.get('/tour_stops.php?years=1');
      return response.data;
    } catch (error) {
      return mockApiResponse({
        records: [2024, 2023]
      }).then(res => res.data);
    }
  },
  
  create: async (data: any) => {
    try {
      const response = await api.post('/tour_stops.php', data);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  
  update: async (data: any) => {
    try {
      const response = await api.put('/tour_stops.php', data);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  
  delete: async (id: number) => {
    try {
      const response = await api.delete('/tour_stops.php', { data: { id } });
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }
};

function toCamelCase(obj: any): any {
  if (Array.isArray(obj)) {
    return obj.map(toCamelCase);
  } else if (obj !== null && typeof obj === 'object') {
    return Object.entries(obj).reduce((acc, [key, value]) => {
      const camelKey = key.replace(/_([a-z])/g, g => g[1].toUpperCase());
      acc[camelKey] = toCamelCase(value);
      return acc;
    }, {} as any);
  }
  return obj;
}


export const registrationsAPI = {
  getAll: async (params = {}) => {
    try {
     const response = await api.get('/registrations.php', { params: { ...params, admin: 'true' } });
return toCamelCase(response.data); // conversion ici
    } catch (error) {
      return mockApiResponse({
        records: [
          {
            id: 1,
            confirmationNumber: 'ASC123456789',
            firstName: 'Mamadou',
            lastName: 'Diallo',
            email: 'mamadou.diallo@email.com',
            phone: '+221 77 123 45 67',
            country: 'Sénégal',
            federation: 'Fédération Sénégalaise de Surf',
            category: 'mens-open',
            experience: 'advanced',
            emergencyContact: 'Fatou Diallo',
            emergencyPhone: '+221 77 987 65 43',
            medicalInfo: 'Aucune allergie connue',
            eventId: 3,
            submittedAt: '2024-04-15T10:30:00Z',
            status: 'confirmed'
          },
          {
            id: 2,
            confirmationNumber: 'ASC987654321',
            firstName: 'Aicha',
            lastName: 'Kone',
            email: 'aicha.kone@email.com',
            phone: '+225 07 12 34 56',
            country: 'Côte d\'Ivoire',
            federation: 'Fédération Ivoirienne de Surf',
            category: 'womens-open',
            experience: 'intermediate',
            emergencyContact: 'Ibrahim Kone',
            emergencyPhone: '+225 07 98 76 54',
            medicalInfo: '',
            eventId: 3,
            submittedAt: '2024-04-16T14:20:00Z',
            status: 'pending'
          }
        ],
        pagination: {
          current_page: 1,
          total_pages: 1,
          total_records: 2,
          limit: 15
        }
      }).then(res => res.data);
    }
  },

  getById: async (id: number) => {
    try {
      const response = await api.get(`/registrations.php?id=${id}`);
      return response.data;
    } catch (error) {
      return mockApiResponse({
        id: 1,
        confirmationNumber: 'ASC123456789',
        firstName: 'Mamadou',
        lastName: 'Diallo',
        email: 'mamadou.diallo@email.com',
        phone: '+221 77 123 45 67',
        country: 'Sénégal',
        federation: 'Fédération Sénégalaise de Surf',
        category: 'mens-open',
        experience: 'advanced',
        emergencyContact: 'Fatou Diallo',
        emergencyPhone: '+221 77 987 65 43',
        medicalInfo: 'Aucune allergie connue',
        eventId: 3,
        submittedAt: '2024-04-15T10:30:00Z',
        status: 'confirmed'
      }).then(res => res.data);
    }
  },

  getByConfirmation: async (confirmationNumber: string) => {
    try {
      const response = await api.get(`/registrations.php?confirmation=${confirmationNumber}`);
      return response.data;
    } catch (error) {
      return mockApiResponse({
        id: 1,
        confirmationNumber: confirmationNumber,
        firstName: 'Mamadou',
        lastName: 'Diallo',
        email: 'mamadou.diallo@email.com',
        status: 'confirmed'
      }).then(res => res.data);
    }
  },

  getByEvent: async (eventId: number) => {
    try {
      const response = await api.get(`/registrations.php?event_id=${eventId}`);
      return response.data;
    } catch (error) {
      return mockApiResponse({
        records: [
          {
            id: 1,
            confirmationNumber: 'ASC123456789',
            firstName: 'Mamadou',
            lastName: 'Diallo',
            country: 'Sénégal',
            category: 'mens-open',
            status: 'confirmed'
          }
        ]
      }).then(res => res.data);
    }
  },

create: async (data: any) => {
  try {
    const toSnakeCase = (obj: Record<string, any>) => {
      const result: Record<string, any> = {};
      for (const key in obj) {
        const snakeKey = key.replace(/([A-Z])/g, '_$1').toLowerCase();
        result[snakeKey] = obj[key];
      }
      return result;
    };

    const snakeData = toSnakeCase(data);

    const response = await api.post('/registrations.php', snakeData);
    return response.data;
  } catch (error) {
    // Fallback de secours
    const confirmationNumber = 'ASC' + Date.now().toString().slice(-6) + Math.floor(Math.random() * 1000).toString().padStart(3, '0');
    return mockApiResponse({
      success: true,
      confirmationNumber: confirmationNumber,
      registrationId: Math.floor(Math.random() * 1000) + 1,
      message: 'Inscription enregistrée avec succès ! Vous recevrez une confirmation par email.'
    }).then(res => res.data);
  }
},

  updateStatus: async (id: number, status: string) => {
    try {
      const response = await api.put('/registrations.php', { id, status });
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  delete: async (id: number) => {
    try {
      const response = await api.delete('/registrations.php', { data: { id } });
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }
};

export const contactAPI = {
  send: async (data: {
    name: string;
    email: string;
    subject: string;
    message: string;
    type: string;
  }) => {
    try {
      const response = await api.post('/contact.php', data);
      return response.data;
    } catch (error) {
      return mockApiResponse({
        message: "Message sent successfully."
      }).then(res => res.data);
    }
  },
  
  getAll: async (params: { status?: string; type?: string; limit?: number; page?: number } = {}) => {
    try {
      const response = await api.get('/contact.php', { 
        params: { ...params, admin: true } 
      });
      return response.data;
    } catch (error) {
      return mockApiResponse({
        records: [
          {
            id: 1,
            name: 'John Doe',
            email: 'john@example.com',
            subject: 'Demande d\'information',
            message: 'Bonjour, je souhaiterais obtenir plus d\'informations sur vos programmes.',
            type: 'general',
            status: 'new',
            created_at: '2024-12-15T10:00:00Z'
          }
        ],
        pagination: {
          current_page: 1,
          total_pages: 1,
          total_records: 1,
          limit: 10
        }
      }).then(res => res.data);
    }
  },
  
  getById: async (id: number) => {
    try {
      const response = await api.get(`/contact.php?id=${id}&admin=true`);
      return response.data;
    } catch (error) {
      return mockApiResponse({
        id: 1,
        name: 'John Doe',
        email: 'john@example.com',
        subject: 'Demande d\'information',
        message: 'Bonjour, je souhaiterais obtenir plus d\'informations sur vos programmes.',
        type: 'general',
        status: 'new',
        created_at: '2024-12-15T10:00:00Z'
      }).then(res => res.data);
    }
  },
  
  updateStatus: async (id: number, status: string) => {
    try {
      const response = await api.put('/contact.php', { id, status });
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  
  delete: async (id: number) => {
    try {
      const response = await api.delete('/contact.php', { data: { id } });
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }
};

export const newsletterAPI = {
  subscribe: async (email: string, language: string = 'fr') => {
    try {
      const response = await api.post('/newsletter.php', { email, language });
      return response.data;
    } catch (error) {
      return mockApiResponse({
        message: "Successfully subscribed to newsletter."
      }).then(res => res.data);
    }
  },
  
  unsubscribe: async (email: string) => {
    try {
      const response = await api.delete('/newsletter.php', { data: { email } });
      return response.data;
    } catch (error) {
      return mockApiResponse({
        message: "Successfully unsubscribed from newsletter."
      }).then(res => res.data);
    }
  },
  
  getAll: async (params: { status?: string; limit?: number; page?: number } = {}) => {
    try {
      const response = await api.get('/newsletter.php', { 
        params: { ...params, admin: true } 
      });
      return response.data;
    } catch (error) {
      return mockApiResponse({
        records: [
          {
            id: 1,
            email: 'subscriber@example.com',
            language: 'fr',
            status: 'active',
            subscribed_at: '2024-12-15T10:00:00Z',
            unsubscribed_at: null
          }
        ],
        pagination: {
          current_page: 1,
          total_pages: 1,
          total_records: 1,
          limit: 10
        }
      }).then(res => res.data);
    }
  }
};

export const statisticsAPI = {
  getAll: async () => {
    try {
      const response = await api.get('/statistics.php');
      return response.data;
    } catch (error) {
      return mockApiResponse({
        federations: 15,
        tour_stops: 50,
        athletes: 300,
        experience: 8
      }).then(res => res.data);
    }
  }
};

export const slidersAPI = {
  getAll: async (activeOnly: boolean = true) => {
    try {
      const params = activeOnly ? { active_only: true } : {};
      const response = await api.get('/sliders.php', { params });
      return response.data;
    } catch (error) {
      return mockApiResponse({
        records: [
          {
            id: 1,
            title_fr: 'Ride the African Wave',
            title_en: 'Ride the African Wave',
            subtitle_fr: 'L\'Afrique unie sur la vague. Découvrez la passion du surf africain.',
            subtitle_en: 'Africa united on the wave. Discover the passion of African surfing.',
            image_url: 'https://images.pexels.com/photos/1212600/pexels-photo-1212600.jpeg?auto=compress&cs=tinysrgb&w=1600',
            button_text_fr: 'Explorer la Tournée',
            button_text_en: 'Explore the Tour',
            button_url: '/africa-surf-tour',
            active: true,
            order_position: 1
          },
          {
            id: 2,
            title_fr: 'Africa Surf Tour 2025',
            title_en: 'Africa Surf Tour 2025',
            subtitle_fr: 'Suivez nos athlètes à travers les plus beaux spots du continent.',
            subtitle_en: 'Follow our athletes through the continent\'s most beautiful spots.',
            image_url: 'https://images.pexels.com/photos/1430672/pexels-photo-1430672.jpeg?auto=compress&cs=tinysrgb&w=1600',
            button_text_fr: 'Voir le Calendrier',
            button_text_en: 'View Calendar',
            button_url: '/africa-surf-tour',
            active: true,
            order_position: 2
          },
          {
            id: 3,
            title_fr: 'Talents Africains',
            title_en: 'African Talents',
            subtitle_fr: 'Découvrez les surfeurs qui portent l\'Afrique vers l\'excellence.',
            subtitle_en: 'Discover the surfers taking Africa to excellence.',
            image_url: 'https://images.pexels.com/photos/1308881/pexels-photo-1308881.jpeg?auto=compress&cs=tinysrgb&w=1600',
            button_text_fr: 'Découvrir les Talents',
            button_text_en: 'Discover Talents',
            button_url: '/talents',
            active: true,
            order_position: 3
          }
        ]
      }).then(res => res.data);
    }
  },
  
  getById: async (id: number) => {
    try {
      const response = await api.get(`/sliders.php?id=${id}`);
      return response.data;
    } catch (error) {
      return mockApiResponse({
        id: id,
        title_fr: 'Ride the African Wave',
        title_en: 'Ride the African Wave',
        subtitle_fr: 'L\'Afrique unie sur la vague. Découvrez la passion du surf africain.',
        subtitle_en: 'Africa united on the wave. Discover the passion of African surfing.',
        image_url: 'https://images.pexels.com/photos/1212600/pexels-photo-1212600.jpeg?auto=compress&cs=tinysrgb&w=1600',
        button_text_fr: 'Explorer la Tournée',
        button_text_en: 'Explore the Tour',
        button_url: '/africa-surf-tour',
        active: true,
        order_position: 1
      }).then(res => res.data);
    }
  },
  
  create: async (data: any) => {
    try {
      const response = await api.post('/sliders.php', data);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  
  update: async (data: any) => {
    try {
      const response = await api.put('/sliders.php', data);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  
  delete: async (id: number) => {
    try {
      const response = await api.delete('/sliders.php', { data: { id } });
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }
};

export const adminAPI = {
  login: async (email: string, password: string) => {
    try {
      const response = await api.post('/admin.php', {
        action: 'login',
        email,
        password
      });
      return response.data;
    } catch (error) {
      // Pour la démo, on simule une connexion réussie
      if (email === 'admin@ascsurf.com' && password === 'admin123') {
        return mockApiResponse({
          message: "Login successful.",
          token: "mock_token_" + Date.now(),
          user: {
            id: 1,
            name: "Administrateur ASCsurf",
            email: "admin@ascsurf.com",
            role: "admin"
          }
        }).then(res => res.data);
      }
      return Promise.reject(error);
    }
  },
  
  getStats: async () => {
    try {
      const response = await api.post('/admin.php', { action: 'get_stats' });
      return response.data;
    } catch (error) {
      return mockApiResponse({
        news: 3,
        athletes: 3,
        federations: 3,
        partners: 2,
        galleries: 2,
        sliders: 3,
        users: 1,
        messages: 5,
        activity: [
          {
            type: 'news',
            title: 'Africa Surf Tour 2025 : Les Dates Révélées',
            date: '2024-12-01T10:00:00Z',
            action: 'Nouvel article publié'
          },
          {
            type: 'athlete',
            title: 'Cherif Fall',
            date: '2024-11-15T14:30:00Z',
            action: 'Athlète ajouté'
          },
          {
            type: 'gallery',
            title: 'Africa Surf Tour 2024 - Sénégal',
            date: '2024-11-10T16:00:00Z',
            action: 'Galerie mise à jour'
          }
        ]
      }).then(res => res.data);
    }
  },
  
  getUsers: async () => {
    try {
      const response = await api.post('/admin.php', { action: 'get_users' });
      return response.data;
    } catch (error) {
      return mockApiResponse({
        records: [
          {
            id: 1,
            email: 'admin@ascsurf.com',
            name: 'Administrateur ASCsurf',
            role: 'admin',
            active: true,
            last_login: '2024-12-15T10:00:00Z',
            created_at: '2024-01-01T00:00:00Z'
          }
        ]
      }).then(res => res.data);
    }
  },
  
  createUser: async (data: any) => {
    try {
      const response = await api.post('/admin.php', {
        action: 'create_user',
        ...data
      });
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  
  updateUser: async (data: any) => {
    try {
      const response = await api.post('/admin.php', {
        action: 'update_user',
        ...data
      });
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  
  deleteUser: async (id: number) => {
    try {
      const response = await api.post('/admin.php', {
        action: 'delete_user',
        id
      });
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }
};

// API de debug pour diagnostiquer les problèmes
export const debugAPI = {
  getInfo: async () => {
    try {
      const response = await api.get('/debug.php');
      return response.data;
    } catch (error) {
      console.error('Debug API failed:', error);
      return null;
    }
  }
};

export default api;